var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMemberCount = function SvgMemberCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32313F",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M23.185 10.97c-.31-.31-.798-.4-1.197-.266l-2.615.886-2.836-3.191C16.315 8.133 15.96 8 15.606 8a1.37 1.37 0 0 0-.887.488l-2.083 3.102-3.146-.93c-.4-.134-.843 0-1.108.265-.31.266-.444.71-.355 1.108l1.906 7.978c.133.532.576.93 1.152.93h8.953c.532 0 .975-.354 1.108-.841l2.35-7.934c.132-.443 0-.886-.311-1.196Zm-3.28 8.598h-8.687l-1.861-7.58 2.97.887c.487.133 1.019-.044 1.284-.443l2.04-2.97 2.747 3.103c.31.355.798.488 1.241.31l2.438-.842-2.172 7.535Zm2.792 3.102H8.825a.68.68 0 0 0-.665.665c0 .355.266.665.665.665h13.917c.354 0 .664-.31.664-.665 0-.354-.31-.665-.709-.665Z"
  }))));
};
export default SvgMemberCount;